module.exports = __webpack_public_path__ + "img/top-20-photo-1.a06a89a4.jpg";